import EsusView from 'components/esus/EsusView'

export default function MarcadoresConsumoAlimentarView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoMarcadoresConsumo' />
}
